<script>
import { TTB } from '@splidejs/splide';
import { set } from 'lodash';
import Tab from './Tab.vue';
import {nextTick} from "vue";

export default {
    name: "Tabs",

    emits: ['tab-changed'],

    components: [Tab],

    data() {
        return {
            activeTabIndex : 0,
            tabs: [],
            currentURL: null,
            searchParams: null,
        };
    },
    
    created() {
        nextTick(this.initTabs);
    },

    mounted() {
        this.setCurrentUrl();
    },

    methods: {
        initTabs() {
            let focus = this.searchParams.get('tab');

            const lists = this.$el.querySelectorAll('.our-brands__list');

            for (let key in lists) {
                const dataset =  lists[key].dataset;
                const name = dataset ? dataset.name : '';
                const id = name.toLowerCase();
                if (!  ['bobiler', 'campingvogner'].includes(id)) {
                    // console.log(id);
                    continue;
                }

                const tab  = { id : id,  isActive : false, name: name }
                this.tabs.push(tab);
            }

            if (this.tabs.length > 0) {
                this.tabs[0].isActive = true;
            }

            let activeTab = this.tabs.filter(el => el.isActive);
            if(activeTab.length && focus){
                setTimeout(() => {
                    document.querySelector('#' + focus).scrollIntoView();
                }, 500);
                return false;
            }
        },

        selectTab(id) {
            this.tabs.forEach((tab) => tab.isActive = (tab.id === id));
            this.setGetParam('tab', id);
            this.$emit('tab-changed', id);
        },

        setCurrentUrl() {
            this.currentURL = new URL(window.location.href);
            this.searchParams = this.currentURL.searchParams;
        },

        setGetParam(name, value) {
            this.searchParams.set(name, value);
            this.currentURL.search = this.searchParams.toString();
            history.replaceState(null,null, this.currentURL.toString());
        },

        getQueryParam(name) {
            return this.searchParams.get(name);
        }
    },

}

</script>

<template>
    <div class="tabs">
        <div class="tabs__buttons">
            <button
                v-for="tab in tabs"
                :class="{ 'button-tertiary--active': tab.isActive }"
                :id="tab.id"
                @click.prevent="selectTab(tab.id)"
                class="button-tertiary mr-3"
            >
                {{ tab.name }}
            </button>
        </div>
        <slot></slot>
    </div>
</template>